export const partners = [
  {
    name: 'Makerere University Business School',
    logo: '/images/MUBS-logo.jpeg',
    website: 'https://www.mubs.ac.ug/'
  },
  {
    name: 'Africa Research and Impact Network',
    logo: '/images/Arin-logo.jpg',
    website: 'https://www.arin-africa.org/'
  },
  {
    name: 'Frankfurt School of Finance & Management',
    logo: '/images/Frankfurt-School-logo.jpg',
    website: 'https://www.fs-unep-centre.org/'
  }
];